var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section bg-home home-half scroll-select .desktop-only",attrs:{"id":"home"}},[_c('div',{staticClass:"bg-overlay-top"})])
}]

export { render, staticRenderFns }